export const initialState = {
    name: '',
    headerValue: '',
    minChannels: '',
    incSize: '',
    teamsEnabled: false,
    sipEnabled: false,
    shared: false,
};

export const trunkTypesPath = '/trunk-types';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Trunk Types', path: trunkTypesPath },
    { label: 'Add Trunk Type', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Trunk Types', path: trunkTypesPath },
    { label: 'Edit Trunk Type', path: '' },
];

export const addHeader = 'Trunk Type Details';
export const editHeader = 'Edit Trunk Type Details';
